import { useContext, useState, useCallback } from 'react';
import { Modal } from 'bootstrap';
import ViewCallAnalysisModal from './ViewCallAnalysisModal';
import { axiosClient } from '../../../../library/Service/axiosClient';
import { SmartContext } from '../../../../library/Core/SmartContext';
import StudentDropdownEdit from './StudentDropdownEdit';

type CallRecording = {
    id: number;
    call_id: string | number;
    recording_url: string;
    call_time: string;
    status: 'analyzed' | 'request_sent' | '' | null;
    analysis_details?: unknown;
    student_id: string | number;
    call_category?: string;
};

const CallRecordingSection = ({ callRecordings, refresRecordings }: { callRecordings: CallRecording[]; refresRecordings: () => void }) => {
    const { state } = useContext(SmartContext);
    const [analysisData, setAnalysisData] = useState<CallRecording | null>(null);

    function formatDateTime(dateString: string) {
        const date = new Date(dateString);
        const options: Intl.DateTimeFormatOptions = {
            year: 'numeric',
            month: 'short',
            day: 'numeric',
            hour: '2-digit',
            minute: '2-digit',
            hour12: true,
        };
        return date.toLocaleString('en-US', options);
    }

    const openAnalysisModal = useCallback((rec: CallRecording) => {
        setAnalysisData(rec);
        setTimeout(() => {
            const el = document.getElementById('analysisModal');
            if (!el) {
                console.error('Modal element #analysisModal not found');
                return;
            }
            const instance = Modal.getOrCreateInstance(el);
            instance.show();
        }, 0);
    }, []);

    const sendRecordingToAnalysis = async (mp3UrlId: number) => {
        try {
            const base = process.env.REACT_APP_APP_BASE_URL;
            const url = `${base}/hope/call-analysis/send/${mp3UrlId}?user_uuid=${state.internal.model.id}`;
            const res = await axiosClient().post(url);
            if (res.status === 200) {
                refresRecordings();
            } else {
                alert('Error sending analysis request');
            }
        } catch (err) {
            console.error('Error sending analysis request:', err);
            alert('Error sending analysis request');
        }
    };

    return (
        <div className="tab-pane fade show active" id="pills-officeUsage" role="tabpanel" aria-labelledby="pills-officeUsage-tab">
            <div className="underGraduate-detail">
                <div className="blockHeader">
                    <div className="row g-2 align-items-center">
                        <div className="col">
                            <div className="title d-flex align-items-center justify-content-between">
                                <span>
                                    <i className="icon icon-world"></i> Call Recording
                                </span>
                                <button className="btn btn-sm btn-success" onClick={refresRecordings}>
                                    Refresh Recordings
                                </button>
                            </div>
                        </div>
                    </div>
                </div>

                <div className="graduateRow edit">
                    <div className="col-xl-12">
                        <div className="row g-4">
                            {Array.isArray(callRecordings) &&
                                callRecordings.map((rec, index) => (
                                    <div key={rec.call_id} className="col-12">
                                        <div className='shadow-sm p-3 rounded'>
                                            <div className='row g-2'>
                                                <div className='col-12'>
                                                    <div className='row g-2'>
                                                        <div className='col'><span className="me-3 fw-bold">{index + 1}. Recorded Session</span> </div>
                                                        <div className='col-auto'>
                                                            <span className="ms-3 text-muted">{formatDateTime(rec.call_time)}</span>

                                                            {rec.status === 'analyzed' && <span className="badge bg-success ms-3 px-2 py-1 font-500">Analysis Completed</span>}

                                                            {rec.status === 'request_sent' && (
                                                                <span className="badge bg-warning rounded-pill text-dark ms-3 px-2 py-1 font-500">Request Sent</span>
                                                            )}
                                                            {(rec.status === '' || rec.status == null) && (
                                                                <span className="badge bg-secondary rounded-pill ms-3 px-2 py-1 font-500">Not Requested</span>
                                                            )}

                                                        </div>
                                                    </div>



                                                </div>
                                                <div className='col-12'>
                                                    <div className='row g-2 align-items-center'>
                                                        <div className='col-md-6'>
                                                            <audio controls preload="none" className='w-100' /*style={{ flex: 1 }}*/>
                                                                <source src={rec.recording_url} type="audio/mpeg" />
                                                                Your browser does not support the audio element. 
                                                            </audio>
                                                        </div>
                                                        <div className='col-md-6'>
                                                            <div className='row g-2 justify-content-end align-items-center'>
                                                                {/* Pass the saved call_category (if available) as initialCategory */}
                                                                <StudentDropdownEdit studentId={rec.id} initialCategory={rec.call_category} />

                                                                {/* Request Analysis button */}
                                                                {(rec.status === '' || rec.status == null) && (
                                                                    <div className='col-auto'>
                                                                        <button className="btn btn-sm btn-primary height-40 rounded-pill d-flex align-items-center px-3" onClick={() => sendRecordingToAnalysis(rec.id)}>
                                                                            Request Analysis 
                                                                        </button>
                                                                    </div>
                                                                )}

                                                                <div className='col-auto'>{/* View Analysis button */}
                                                                    <button
                                                                        className="btn btn-sm btn-primary height-40 rounded-pill d-flex align-items-center px-3"
                                                                        onClick={() => openAnalysisModal(rec)}
                                                                        disabled={rec.status !== 'analyzed'}>
                                                                        View Analysis
                                                                    </button></div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>










                                        </div>

                                    </div>
                                ))}
                        </div>
                    </div>
                </div>
            </div>

            <ViewCallAnalysisModal rec={analysisData} />
        </div>
    );
};

export default CallRecordingSection;
